import Landing from './Landing';
import ListInvites from './ListInvites';
import ViewInvite from './ViewInvite';

window.Vue.component('MerchantLanding', Landing);
window.Vue.component('MerchantListInvites', ListInvites);
window.Vue.component('MerchantViewInvite', ViewInvite);
